import React, { useEffect, useMemo, useRef } from 'react';
import {MTableActions, MTableBody, MTableHeader} from 'material-table';
import classNames from 'classnames';
import style from './StickyTableActions.module.less';

function CustomTableActions(props) {
  const { WrapperComponent, actionProps,haveChild,...rest } = props
  const ref = useRef();
// type - 'TD', 'TR', 'TH'
  const setStyleAndClassForRef = (overridedContextChild,overridedContextParent, className,type) => {
    let childComponent;
    if(haveChild){
      if (!!overridedContextChild && overridedContextChild.nodeName === type) {
        childComponent = Object.assign(overridedContextChild)
        overridedContextChild.className = classNames(overridedContextChild.className, className);
        overridedContextChild.style.minWidth = !!rest?.actionWidth && rest.actionWidth
      }
    }
    if (!!overridedContextParent && overridedContextParent.nodeName === type) {
      overridedContextParent.className = classNames(overridedContextParent.className, className);
      overridedContextParent.style.minWidth = !!rest?.actionWidth && rest.actionWidth
      if(haveChild){
        overridedContextParent.style.left = (childComponent.offsetWidth+'px')
      }
    }
  }



  const getParentViaComponent = () => {
    let overridedContext;
    switch (WrapperComponent) {
      case MTableActions: {
        haveChild
            ? setStyleAndClassForRef(
            ref.current?.parentNode?.parentNode?.parentNode?.firstChild,
            ref.current?.parentNode?.parentNode,
            style.tdContainer,
            'TD')
            : setStyleAndClassForRef(
                null,
                ref.current?.parentNode?.parentNode,
                style.tdContainer,
                'TD')
      }
        case MTableHeader:{
          haveChild
              ? setStyleAndClassForRef(
               ref.current?.firstChild?.firstChild?.childNodes[0],
               ref.current?.firstChild?.firstChild?.childNodes[1],
              style.thContainer,
              'TH')
              :
              setStyleAndClassForRef(
                  null,
                  ref.current?.firstChild?.firstChild?.childNodes[0],
                  style.thContainer,
                  'TH')
        }
      case MTableBody:{
        haveChild
            ? setStyleAndClassForRef(
                ref.current?.firstChild?.firstChild?.childNodes[0],
                ref.current?.firstChild?.firstChild?.childNodes[1],
                style.tdContainerWithBackground,
                'TD')
            :
            setStyleAndClassForRef(
                null,
                ref.current?.firstChild?.firstChild?.childNodes[0],
                style.tdContainerWithBackground,
                'TD')
      }
        default:
            return ;
    }
  };
  useEffect(() => {
    getParentViaComponent();
  }, []);
  return (
    <div style={{display:"contents"}} ref={ref}>
      <WrapperComponent {...actionProps} />
    </div>
  );
}

export default CustomTableActions;
